import { toast } from 'react-toastify';
import {
  clearStatusCustomLabel,
  isApiError,
  setStatusCustomLabel,
} from 'src/services/client';

export interface UseCustomStatusesAPIReturn {
  setLabel: (statusId: string, customLabel: string) => Promise<boolean>;
  clearLabel: (statusId: string) => Promise<boolean>;
}

const SAVE_ERROR: string = 'Could not save the custom label. Please try again.';

const errorToast = (message: string): void => {
  toast.error('🚫 ' + message, { autoClose: 8000, position: 'top-center' });
};

export const useCustomStatusesAPI = (): UseCustomStatusesAPIReturn => {
  const setLabel = async (
    statusId: string,
    customLabel: string
  ): Promise<boolean> => {
    const trimmed: string = customLabel.trim();

    if (!trimmed) {
      return false;
    }

    const response: any = await setStatusCustomLabel(statusId, trimmed);

    if (isApiError(response)) {
      errorToast(SAVE_ERROR);
      return false;
    }

    return true;
  };

  const clearLabel = async (statusId: string): Promise<boolean> => {
    const response: any = await clearStatusCustomLabel(statusId);

    if (isApiError(response)) {
      errorToast(SAVE_ERROR);
      return false;
    }

    return true;
  };

  return {
    setLabel,
    clearLabel,
  };
};
